/****************************************************
 * Module Name:  addLabModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import LabProxy from "../../utility/proxy/manager/labProxy";
import Constants from "../../utility/constants";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddLabModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newlab: this.props.editOperation ? this.props.sourceData.name : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newaddress: this.props.editOperation ? this.props.sourceData.address : "",
      newlocationid: this.props.editOperation
        ? this.props.sourceData.locationid
        : "",
      newfullLocation: this.props.editOperation
        ? {
          value: this.props.sourceData.locationid,
          label: this.props.sourceData.location,
        }
        : { value: 0, label: "Error" },
      newpincode: this.props.editOperation ? this.props.sourceData.pincode : "",
      newphone: this.props.editOperation ? this.props.sourceData.phone : "",
      newmobile: this.props.editOperation ? this.props.sourceData.mobile : "",
      newfax: this.props.editOperation ? this.props.sourceData.fax : "",
      newwebref: this.props.editOperation ? this.props.sourceData.webref : "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",

      showError: false,

      fullLocation: [],
      fullLocationOptions: [],
      showLocationLoadSpinner: true,

      validateLabPresentSpinner: false,
      showValidationMessage: false,
      labAvailable: true,

      labValidationError: "",
      pincodeValidationError: "",
      mobileValidationError: "",
    };
    this.getAllLocationList(false);
  }

  getAllLocationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLocationLoadSpinner: true });
    LocationProxy.GetAllLocationDetail((response) =>
      this.setAllLocationData(response)
    );
  };

  setAllLocationData = (response) => {
    let cOptions = [];
    let nnewfullLocation = this.state.newfullLocation;
    response.map((data) => {
      let iOption = { value: data.id, label: data.name + " | " + data.country };
      cOptions.push(iOption);

      if (data.id === this.state.newfullLocation.value)
        nnewfullLocation = iOption;
      return true;
    });

    //During new creation option select first one as default
    if (nnewfullLocation.value === 0 && cOptions.length > 0)
      nnewfullLocation = cOptions[0];

    this.setState({
      fullLocation: response,
      fullLocationOptions: cOptions,
      newfullLocation: nnewfullLocation,
      showLocationLoadSpinner: false,
    });
  };

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newlab,
      description: this.state.newdescription,
      address: this.state.newaddress,
      locationid: this.state.newfullLocation.value,
      pincode: this.state.newpincode,
      phone: this.state.newphone,
      mobile: this.state.newmobile,
      fax: this.state.newfax,
      webref: this.state.newwebref,
      seq: this.state.newseq
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateLabPresent = (labEntered) => {
    if (!labEntered || labEntered.trim() === "") return;

    this.setState({
      validateLabPresentSpinner: true,
    });

    LabProxy.CheckLabAvailable(labEntered, (response) => {
      //if we got response that means lab is present at backend
      if (response) {
        //LabName already present
        this.setState({
          validateLabPresentSpinner: false,
          showValidationMessage: true,
          labAvailable: false,
        });
      } else {
        //LabName not available, so can be used
        this.setState({
          validateLabPresentSpinner: false,
          showValidationMessage: true,
          labAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      (this.state.mobileValidationError.length > 0 ||
        this.state.pincodeValidationError.length > 0)
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.labAvailable ||
        this.state.mobileValidationError.length > 0 ||
        this.state.pincodeValidationError.length > 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add lab validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" dialogClassName="modal" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Lab" : "Add New Lab"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Lab Id.</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>
                        Lab <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newlab}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Lab (required)"
                          size="small"
                          placeholder="Enter Lab"
                          value={this.state.newlab}
                          autoFocus
                          onBlur={(e) =>
                            this.validateLabPresent(this.state.newlab)
                          }
                          onChange={(e) =>
                            this.setState({
                              newlab: e.target.value,
                              showValidationMessage: false,
                              labValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Lab Cannot be Empty",
                            })
                          }
                          helperText={this.state.labValidationError}
                          error={this.state.labValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateLabPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box></Box>
                      ) : this.state.labAvailable ? (
                        <font color="green">Lab available</font>
                      ) : (
                        <font color="red">Lab not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Address</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Address"
                        size="small"
                        placeholder="Enter Address"
                        value={this.state.newaddress}
                        onChange={(e) =>
                          this.setState({ newaddress: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Location</Form.Label>
                    </td>
                    <td style={{ width: "100%", paddingTop: 15 }}>
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={this.state.newfullLocation}
                        isSearchable={true}
                        name="Location"
                        options={this.state.fullLocationOptions}
                        onChange={(selectedOption) =>
                          this.setState({ newfullLocation: selectedOption })
                        }
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                      />
                    </td>
                    <td>
                      {this.state.showLocationLoadSpinner ? (
                        <CircularProgress
                          size="1em"
                          sx={{ mt: 1.5, ml: 0.7 }}
                        />
                      ) : (
                        <Tooltip title="Reload">
                          <RefreshOutlinedIcon
                            color="primary"
                            fontSize="medium"
                            onClick={() => this.getAllLocationList(true)}
                            sx={{ cursor: "pointer", mt: 1 }}
                          />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Pincode</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Pincode"
                        size="small"
                        placeholder="Enter Pincode"
                        value={this.state.newpincode}
                        onChange={(e) =>
                          this.setState({
                            newpincode: e.target.value,
                            pincodeValidationError:
                              e.target.value.length !== 0
                                ? Utility.CheckisNumberGreaterThanZero(
                                  e.target.value
                                )
                                  ? ""
                                  : "Pincode should be a Valid Positive Number"
                                : "",
                          })
                        }
                        helperText={this.state.pincodeValidationError}
                        error={this.state.pincodeValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Phone</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Phone"
                        placeholder="Enter Phone"
                        size="small"
                        value={this.state.newphone}
                        onChange={(e) =>
                          this.setState({ newphone: e.target.value.replace(/[^0-9]/gi, "").replace(/^0+/g, "") || "" })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Mobile</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Mobile"
                        size="small"
                        placeholder="Enter Mobile"
                        value={this.state.newmobile}
                        onChange={(e) =>
                          this.setState({
                            newmobile: e.target.value,
                            mobileValidationError:
                              e.target.value.length !== 0
                                ? Utility.CheckIsPhone(e.target.value)
                                  ? ""
                                  : "Mobile should be a Valid Positive Number of 10 Digits"
                                : "",
                          })
                        }
                        helperText={this.state.mobileValidationError}
                        error={this.state.mobileValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Fax</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Fax"
                        placeholder="Enter Fax"
                        value={this.state.newfax}
                        onChange={(e) =>
                          this.setState({ newfax: e.target.value.replace(/[^0-9]/gi, "").replace(/^0+/g, "") || "0" })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width={'23%'}>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Web Reference</Form.Label>
                    </td>
                    <td width={'77%'}>
                      <TextField
                        size="small"
                        margin="normal"
                        fullWidth
                        label="Web Reference"
                        placeholder="Enter Web Reference"
                        value={this.state.newwebref}
                        onChange={(e) =>
                          this.setState({ newwebref: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label style={{ alignSelf: 'center', paddingTop: 4 }}>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              variant="contained"
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
